import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Component, OnInit, Input, ElementRef, AfterViewInit, inject, input, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass, NgTemplateOutlet, NgStyle } from '@angular/common';

@Component({
    selector: 'exl-expandable-text',
    templateUrl: './expandable-text.component.html',
    styleUrls: ['./expandable-text.component.scss'],
    host: {
        'class': 'exl-expandable-text'
    },
    imports: [NgClass, NgTemplateOutlet, NgStyle, MatTooltip, MatButton, MatIcon, TranslateModule]
})
export class ExpandableTextComponent implements OnInit, AfterViewInit {
    private sanitizer = inject(DomSanitizer);

    /* the Text content itself */
    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() text;
    /* If defined, the button will become a text button with the passed label.
    * otherwise an icon-button (down-arrow) will show instead
    */
    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() buttonLabel:string;
    /* Whether the button appears at the end of the last visible row (true), or below the entire content (false) */
    readonly buttonInline = input(true);
    /* Visibly smaller button */
    readonly buttonSize = input<'normal' | 'small'>('small');
    /* Tooltip for the expand button */
    readonly tooltipText = input('research.profile.overview.show.more.tooltip');
    /* How many lines we wish to see before cropping */
    readonly visibleLines = input(3);
    /* Set color for the blur effect (default - app bg default) */
    readonly blurColor = input<string>(undefined);

    readonly content = viewChild<ElementRef>('content');
    readonly contentWrapper = viewChild<ElementRef>('contentWrapper');

    /* Whether the text exceeds it's container size */
    textExceeds = false;
    /* the ratio by which the container grows/shrinks in height as it responds to screen size */
    responseRatio = 3.5;
    /* Container is expanded or cropping */
    expanded = false;
    /* units for measuring */
    base = 1;
    baseUnit = 'rem';
    /* bind dynamially calculated styles to the text container */
    elStyle: object;
    /* holds the gradient for the blur - when blurColor passed as input */
    gradient: string;

    /* variables to store the final calculated styles - of SfeStyle type to avoid sanitization warnings*/
    calcHeight: SafeStyle;
    calcMinHeight: SafeStyle;

    ngOnInit() {
        this.setElementStyles();
    }

    ngAfterViewInit(){
        if (!this.checkTextExceed(this.contentWrapper().nativeElement.offsetHeight, this.content().nativeElement.offsetHeight)) {
            setTimeout(() => {
                this.expanded = true;
            }, 0);
        }
    }

    /* calculate the container height based on number of rows set above */
    setElementStyles() {
        const lines = this.visibleLines();
        const base = this.base;
        const unit = this.baseUnit;
        const ratio = this.responseRatio;
        this.calcHeight = this.sanitize(`calc( ( ${lines}${unit} + -${lines}vw ) * ${ratio} )`);
        this.calcMinHeight = this.sanitize(`calc(${lines}${unit} + ${base}${unit})`);
    }

    // test if text exceeds it's parent
    checkTextExceed(wrapper, content){
        return wrapper <= content;
    }

    // Expand to see entire text - uni-directional
    expandTextContainer(){
        this.expanded = true;
    }

    getBgBlur(){
        return `linear-gradient(to bottom, ${this.blurColor()}00 0%, ${this.blurColor()} 100%)`;
    }

    sanitize(style){
        return this.sanitizer.bypassSecurityTrustStyle(style);
    }

}
